import { render, staticRenderFns } from "./SalesPipelineEditorItem.vue?vue&type=template&id=cfcf8b40&scoped=true&"
import script from "./SalesPipelineEditorItem.vue?vue&type=script&lang=js&"
export * from "./SalesPipelineEditorItem.vue?vue&type=script&lang=js&"
import style0 from "./SalesPipelineEditorItem.vue?vue&type=style&index=0&id=cfcf8b40&lang=scss&scoped=true&"
import style1 from "./SalesPipelineEditorItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcf8b40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VRow,VSelect})
